import { useState, useCallback } from 'react';
import CSS from 'csstype';
import styles from './addChildren.module.scss';
import { gql, useQuery } from '@apollo/client';
import Spinner from 'src/components/spinner/Spinner';
import { Children, InviteTypeEnum, SelectOption } from '../../../types';
import ChildProfile from '../../../components/homeschool-invite-childrens/ChildProfile';
import { TextInputValue } from '../../../components/text-input/TextInput';
import Button from '../../../components/button/Button';
import IconClose from '../../../assets/icons/close.svg?react';
import ChildForm from 'src/components/homeschool-invite-childrens/ChildForm';
import {useHistory} from 'react-router-dom';
import { logger } from '../../../utils/logger';

export const options = [
    { label: "They will use my account", value: InviteTypeEnum.Parent },
    { label: "They will have their own login", value: InviteTypeEnum.Own }
]

const getChildrens = gql`
    query hsaGetChildren {
        hsaGetChildren {
            id
            email
            firstName
            lastName
            role
            inviteId
            grade
        }
    }
`;

type QueryResponse = {
    hsaGetChildren: Children[];
};

function InviteChildren() {
    const { data, loading } = useQuery<QueryResponse>(getChildrens);
    const history = useHistory();

    const [childrens, setNewChildrens] = useState<Children[]>(data?.hsaGetChildren || []);
    const [backgroundColors, setBackgroundColors] = useState<CSS.Properties[]>([]);

    const randColor = () =>  {
        return "#" + Math.floor(Math.random()*15658734).toString(16).padStart(6, '0').toUpperCase();
    }
    const ranBackground: CSS.Properties = {
        backgroundColor: randColor()
    }

    const handleAddChild = () => {
        const newChild: Children = {
            id: "",
            email: "",
            firstName: "",
            lastName: "",
            role: "",
            inviteId: "",
            grade: ""
        }
        const curr = [...childrens];
        curr.push(newChild);
        setNewChildrens(curr);
        const currColors = [...backgroundColors];
        currColors.push(ranBackground);
        setBackgroundColors(currColors);
    }

    const handleChangeName = (index: number) => (value: TextInputValue) => {
        const updatechildrens = [...childrens];
        updatechildrens[index] = {
            ...updatechildrens[index],
            firstName: value.toString()
        }
        setNewChildrens(updatechildrens);
    }

    const handleChangeEmail = (index: number) => (value: TextInputValue) => {
        const updatechildrens = [...childrens];
        updatechildrens[index] = {
            ...updatechildrens[index],
            email: value.toString()
        }
        setNewChildrens(updatechildrens);
    }

    const handleRemove = (id: number) => () => {
        setNewChildrens(current =>
            current.filter((child, index) => {
                return index !== id
            })
        );
        setBackgroundColors(current =>
            current.filter((color, index) => {
                return index !== id
            })
        );
    }

    const handleSelectGrade = (value: SelectOption) => {
        logger.info('Change grade', value)
    }

    const handleShowCourseContent = () => {

    }

    const handleCreateProfile = useCallback(async () => {

    },[])

    const handleClose = useCallback(() => {
        history.push('/dashboard');
    }, [history]);

    const content = (
        loading ? (
            <div className={styles.spinner}><Spinner /></div>
        ) : (
            <div className={styles.right}>
                <div>
                    <div className={styles.iconClose} onClick={handleClose}>
                        <div className={styles.closeIconWrapper}>
                            <IconClose />
                        </div>
                    </div>
                    <div className={styles.inviteTitle}>Add your children to Open Parachute</div>
                    <div className={styles.rightContent}>
                        {
                            childrens.map((child, index)  => {
                                return (
                                    <ChildProfile key={index} id={index} child={child} color={backgroundColors[index]} onRemove={handleRemove(index)}/>
                                )
                            })

                        }
                        <div className={styles.itemWrapper}>
                            <div onClick={handleAddChild} className={styles.userItem}>
                                <div className={styles.addButton}>+</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={styles.rightDiv}>
                    <div className={styles.childDiv}>
                        {
                            childrens.map((child, index)  => {
                                return (
                                    <ChildForm key={index} id={index} child={child}  color={backgroundColors[index]} onChangeName={handleChangeName(index)} onChangeEmail={handleChangeEmail(index)} onSelectGrade={handleSelectGrade} onRemove={handleRemove(index)}/>
                                )
                            })
                        }
                        <div className={styles.row}>
                            <Button className={styles.seeButton} onClick={handleShowCourseContent} label={'Let me see course content first'} />
                            <Button onClick={handleCreateProfile} label={'Create Profiles'} />
                        </div>
                    </div>
                </div>
            </div>
        )
    )

    const description = (
        <>
            <div className={styles.title}><p>Your children are safe on Open Parachute.</p></div>
            <div className={styles.description}><p style={{ marginBottom: 10 }}>Click to view our <span style={{ color: 'orange' }}>safety</span> and <span style={{ color: 'orange' }}>privacy policy.</span></p></div>
        </>
    )

    return (
        <div className={styles.page}>
            <div className={styles.left}>
                <div className={styles.leftContent}>
                    <h5>
                        {description}
                    </h5>
                </div>
            </div>
            {content}
        </div>
    );
}

export default InviteChildren;